import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { Region } from 'src/app/model/region.model';
import { Student } from 'src/app/model/student/student.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { HelperService } from 'src/app/service/helper.service';
import { ServiceDeliveries } from '../../model/service-deliveries.model';
import { ServiceDeliveryService } from '../../service-delivery/service/service-delivery.service';
import { StudentHelperService } from '../../service/student-helper.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditChildServiceParticipationModalComponent } from '../../edit-child/edit-child-service-participation/edit-child-service-participation-modal/edit-child-service-participation-modal.component';
import { StudentHelper2Service } from '../../service/student-helper2.service';

@Component({
    selector: 'view-child-service-participation',
    templateUrl: './view-child-service-participation.component.html',
    styleUrl: './view-child-service-participation.component.scss'
})
export class ViewChildServiceParticipationComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentHelperNumber: number = 1;

    student: Student;
    serviceDeliveries: ServiceDeliveries[] = [];
    userRegion: Region;
    userSchoolDistricts: any;
    missingCOE: boolean;

    featuresCheck: string[] = ['Edit Service Deliveries'];
    featurePermissions: any = {};
    hasAdminRole: boolean = false;

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();
    simpleDatePipe = new SimpleDatePipe();

    // Table display
    serviceDeliveryDisplayedColumns: string[] = [
        'EDIT',
        'SCHOOL_YEAR',
        'ENROLLMENT_PERIODS.PERIOD',
        'GRADES',
        'SCHOOL_DISTRICTS.DISTRICTS',
        'SCHOOL.NAME',
        'SERVICE_NAME',
        'SERVICE_CODE',
        'START_DATE',
        'END_DATE',
        'COS_REASONS.REASON',
        'SERVICE_HOUR_RANGES.MIN',
        'CREATED_DATE'
    ];

    // Table results
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    regions: any[] = [];
    dataSource: MatTableDataSource<ServiceDeliveries>;

    subs: Subscription[] = [];

    constructor(
        private serviceDeliveryService: ServiceDeliveryService,
        private helperService: HelperService,
        private dialog: MatDialog,
        private studentHelper: StudentHelperService,
        private studentHelper2: StudentHelper2Service,
        private accessService: AccessService
    ) {}

    subscriptions() {
        if (this.studentHelperNumber === 1) {
            let studentSub = this.studentHelper.student$.subscribe((student) => {
                this.student = student;
            });

            this.subs.push(studentSub);
        } else {
            let studentSub = this.studentHelper2.student$.subscribe((student) => {
                this.student = student;
            });

            this.subs.push(studentSub);
        }
    }

    ngOnInit(): void {
        this.subscriptions();
        this.init();
    }

    init() {
        this.isLoading = true;

        this.getServiceDeliveries();
        this.getUserRegion();
        this.getUserSchoolDistricts();
        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    getUserRegion() {
        let deferred = new Promise((resolve, reject) => {
            this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
                this.userRegion = userRegion[0];

                resolve(this.userRegion);
            });
        });

        this.promises.push(deferred);
    }

    getUserSchoolDistricts() {
        let deferred = new Promise((resolve, reject) => {
            this.accessService.getSchoolDistrictAccess().subscribe((schoolDistricts) => {
                if (schoolDistricts) {
                    this.userSchoolDistricts = schoolDistricts;
                }
                resolve(schoolDistricts);
            });
        });

        this.promises.push(deferred);
    }

    getServiceDeliveries() {
        let deferred = new Promise((resolve, reject) => {
            this.serviceDeliveryService.getStudentServices(this.studentId).subscribe((res) => {
                if (res.result) {
                    this.serviceDeliveries = JSON.parse(res.result);

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            this.regions = this.getRegions(this.serviceDeliveries);

            setTimeout(() => {
                this.regions.forEach((region, index) => {
                    let dataSource = new MatTableDataSource<ServiceDeliveries>();
                    dataSource.data = region.SERVICE_DELIVERIES.sort((a: any, b: any) => (a.START_DATE! > b.START_DATE! ? -1 : 1));

                    dataSource.sort = this.sorts.toArray()[index];
                    const defaultSort: Sort = { active: 'SCHOOL_YEAR', direction: 'desc' };
                    dataSource.sort.active = defaultSort.active;
                    dataSource.sort.direction = defaultSort.direction;
                    dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                    region.tableDataSource = dataSource;

                    setTimeout(() => {
                        region.tableDataSource.sort?.sortChange.emit(defaultSort);
                    });
                });
            });
        });
    }

    getRegions(serviceDeliveries: ServiceDeliveries[]) {
        let regions: any[] = [];

        serviceDeliveries.forEach((se) => {
            let regionIndex = regions.findIndex((r) => r.CODE === se.REGION.CODE);

            if (regionIndex === -1) {
                let region: any = se.REGION;
                region.SERVICE_DELIVERIES = [];
                region.SERVICE_DELIVERIES.push(se);

                regions.push(region);
            } else {
                regions[regionIndex].SERVICE_DELIVERIES.push(se);
            }
        });

        // Set user's region to top
        if (this.userRegion) {
            regions = regions.sort((a, b) => (a.CODE! > b.CODE! ? 1 : -1));
            let userRegionIndex = regions.findIndex((r) => r.CODE === this.userRegion.CODE);

            if (userRegionIndex >= 0) {
                regions.splice(0, 0, regions.splice(userRegionIndex, 1)[0]);
            }
        } else {
            regions = regions.sort((a, b) => (a.CODE! > b.CODE! ? 1 : -1));
        }

        return regions;
    }

    getCreatedOn(createdDate: any) {
        return 'Created on ' + this.simpleDatePipe.transform(this.cleanDatePipe.transform(createdDate));
    }

    viewDialog(serviceDelivery?: ServiceDeliveries) {
        let payload: any = {};
        payload.students = [{ ID: this.studentId }];
        if (serviceDelivery) {
            payload.serviceDelivery = serviceDelivery;
            if (serviceDelivery.COS_REASONS?.REASON) {
                payload.cosMode = true;
            }
        }
        payload.mode = 'view';
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(EditChildServiceParticipationModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                console.log(res.msg);
            }
        });
    }
}
